import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { baseUrl } from 'src/environments/environment';
import { City } from '../_models/city.model';
import { Response } from '../_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class CityService {
  cityUrl = 'api/Cities';

  constructor(private http: HttpClient) {}

  getAllCities(): Observable<City[]> {
    return this.http
      .get<Response<{ cities: City[] }>>(this.cityUrl)
      .pipe(map((res) => res.data.cities));
  }

  getCityById(id: number): Observable<any> {
    const cityLocalClone = JSON.parse(sessionStorage.getItem('cities'));
    if (cityLocalClone?.length > 0) {
      const cityIndex = cityLocalClone.findIndex((city) => city.id === id);
      return Observable.create((observer) => {
        observer.next(cityLocalClone[cityIndex]);
        observer.complete();
      });
    } else {
      this.getAllCities();
      return this.http.get(`${this.cityUrl}/${id}`);
    }
  }

  addCity(city: City): Observable<any> {
    return this.http.post(this.cityUrl, city);
  }

  deleteCity(id: number): Observable<any> {
    return this.http.delete(`${this.cityUrl}/${id}`);
  }

  updateCity(city: City): Observable<any> {
    return this.http.put(this.cityUrl, city);
  }

  changeActivationForCity(
    id: number,
    activationFlag: boolean
  ): Observable<any> {
    return this.http.put(`${this.cityUrl}/${id}/${activationFlag}`, {});
  }

  getCitiesByCountryId(countryId: number): Observable<any> {
    return this.http.get(`${this.cityUrl}/GetCitiesByCountryId/${countryId}`);
  }

  saveCityLocalClone(cities): void {
    const citiesStr = JSON.stringify(cities);
    sessionStorage.setItem('cities', citiesStr);
  }

  getStringCityName(id: number): string {
    const cityLocalClone = JSON.parse(sessionStorage.getItem('cities'));


    if (cityLocalClone && cityLocalClone.data.cities?.length > 0) {
      const cityIndex = cityLocalClone.data.cities.findIndex(
        (city) => city.id === id
      );


      return cityLocalClone.data.cities[cityIndex].enName;
    } else {
      this.getAllCities();
      this.http
        .get<Response<City>>(`${this.cityUrl}/${id}`)
        .subscribe((res) => {
          return res.data.enName;
        });
    }
  }

  searchByName(cityName) {
    return this.http.get(`${this.cityUrl}/SearchByName/${cityName}`);
  }
}
